import React from "react";
import PropTypes from "prop-types";
import { Item, Link } from "..";
import ParticipantStatus from "./ParticipantStatus";

const ParticipantItem = ({ label, href, participant, status, visitType }) => (
  <Item
    label={`${label}:`}
    value={
      <React.Fragment>
        {href ? (
          <Link href={href}>
            {participant.name}
          </Link>
        ) : (
          participant.name
        )}
        {status && (
          <ParticipantStatus
            {...status}
            visitType={visitType}
          />
        )}
      </React.Fragment>
    }
  />
);

ParticipantItem.displayName = "ParticipantItem";

ParticipantItem.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  participant: PropTypes.object.isRequired,
  status: PropTypes.object,
  visitType: PropTypes.string.isRequired,
};

export default ParticipantItem;
